import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API_DATA, CLIENT_DATA } from '@frontend/util-api-data';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ChangelogService {
  private http = inject(HttpClient);

  private apiData = inject(API_DATA);
  private client = inject(CLIENT_DATA).name;

  getChangelog(language?: string): Observable<any> {
    let url = this.apiData.apiURL + `api/${this.client}/changelog/de`;
    if (language) {
      url = this.apiData.apiURL + `api/${this.client}/changelog/` + language;
    }
    return this.http.get<any>(url);
  }
}
